import api from '../../../services/api/';
import store from 'store';
import { message } from 'antd';
import { varexeAPIResponseHandler } from '../../../services/api/';
const URL = '/sales';

class InvoiceService {

    // getInvoice(listPageIndex = null, listPerPage = null, listSort = null, listSort = null, listSearch = null, isDeleted = null, idStatus = null ){
    getInvoice(data){
        const  params = [];
        if( data.listPageIndex != undefined && data.listPageIndex != null )
         {
            params.push( "page=" + data.listPageIndex );
         }
        if( data.per_page != undefined && data.per_page != null )
        {
            params.push( "per_page=" + data.per_page );
        }         
         if( data.listSort != undefined && data.listSort != null )
         {
            params.push( "listSort=" + data.listSort );
         }         
         if( data.listSort != undefined && data.listSort != null )
         {
            params.push( "listSort=" + data.listSort );
         }         
         if( data.search != undefined && data.search != null )
         {
            params.push( "search=" + data.search );
         } 
        //  if( data.listFilters != undefined && data.listFilters != null )
        //  {
        //     params.push( "listFilters=" + JSON.stringify(data.listFilters));
        //  }                 
         if( data.is_draft != undefined && data.is_draft != null )
         {
            params.push( "is_draft=" + data.is_draft);
         }                 
        //  if( data.isDeleted != undefined && data.isDeleted != null )
        //  {
        //     params.push( "isDeleted=" + data.isDeleted );
        //  }                         
        if( data.status != undefined && data.status != null )
        {
            params.push( "status=" + data.status );
        } 
        if( data.status_payment != undefined && data.status_payment != null )
        {
            params.push( "status_payment=" + data.status_payment );
        }                          
        //  if( data.generateType != undefined && data.generateType != null )
        //  {
        //     params.push( "generateType=" + data.generateType );
        //  }                         
        return api.get(`${URL}` + (params.length ? '?' + params.join('&') : '' ));
    }


    getListFiltersInvoice(params) {
        return api.get(`${URL}` + params);
    }

    // counts by customer public_id
    getCountByCustomer(customerPublicId) {
        return api.get(`${URL}/customer_counts/${customerPublicId}`);
    }

    // Lightweight outstanding/overdue aggregates for the customer detail summary
    getCustomerInvoiceSummary(customerPublicId) {
        return api.get(`${URL}/customer_summary/${customerPublicId}`);
    }

    createInvoice(invoice, options = {}){
        return api.post(`${URL}`, invoice, options);
    }

    getSaleBlueprint(){
        return api.get(`${URL}/new`);
            
    }
    getInvoiceById(idInvoice){
        return api.get(`${URL}/${idInvoice}`);
            
    }

    getShareLink(publicId) {
        return api.get(`${URL}/${publicId}/share_link`);
    }

    updateShareLink(publicId, data) {
        return api.patch(`${URL}/${publicId}/share_link`, data);
    }

    storeShareLink(publicId, data) {
        return api.post(`${URL}/${publicId}/share_link`, data);
    }

    updateInvoice( idInvoice, invoice, options = {}){
        // If skipAutoErrorHandling is true, errors won't be automatically displayed
        return api.put(`${URL}/${idInvoice}`, invoice, options);
    }

    updateSaleStatus( idInvoice, data){
        return api.put(`${URL}/${idInvoice}/status`, data);
    }
    toggleOnlinePayment(idInvoice, data){
        return api.put(`${URL}/${idInvoice}/online_payment`, data);
    }
    updateInvoiceApproval( idInvoice, data){
        return api.post('sales_approval/' + idInvoice, data);
    }

    getApprovalHistory( idInvoice){
        return api.get('sales_approval/' + idInvoice);
    }
    
    // Add new status transition methods
    transitionStatus(idInvoice, data) {
        return api.put(`${URL}/${idInvoice}/transition`, data);
    }

    confirmInvoice(idInvoice, data = {}) {
        return api.put(`${URL}/${idInvoice}/confirm`, data);
    }

    shipInvoice(idInvoice, data = {}) {
        return api.put(`${URL}/${idInvoice}/ship`, data);
    }

    deliverInvoice(idInvoice, data = {}) {
        return api.put(`${URL}/${idInvoice}/deliver`, data);
    }

    // Lifecycle envelope (state) actions: independent from workflow phase transitions.
    holdInvoice(idInvoice, data) {
        return api.put(`${URL}/${idInvoice}/hold`, data);
    }

    resumeInvoice(idInvoice, data = {}) {
        return api.put(`${URL}/${idInvoice}/resume`, data);
    }

    refundInvoice(idInvoice, data) {
        return api.put(`${URL}/${idInvoice}/refund`, data);
    }
    
    updateIncNotifications(idInvoice, data){
        return api.put(`${URL}/incnotifications/${idInvoice}`, data);
    }
    

    cancelInvoice(idInvoice, data){
        return api.put(`${URL}/${idInvoice}/cancel`, data);
    }

    // updateIncTag(idInvoice, data){
    //     return api.put(URL + '/updateIncTag/'+ idInvoice, data);
    // }
    // deleteIncTag(idTag, data){
    //     return api.put(URL + 'deleteIncTag/' + idTag);
    // }
    
    getSetting(){
        return api.get(`${URL}/setting`);
    }

    updateSetting(params){
        return api.put(`${URL}/setting`, params);
        
    }

    getDesign(){
        return api.get(`${URL}/design`);
    }    
    updateDesign(params){
        return api.put(`${URL}/design`, params);
        
    }



    

    settinglogo(formData){
        return api.post(`${URL}/settinglogo`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            }
          })
    }  
    
    // getINCCustomerBySearch(str){
    //     return api.get(URL + 'search_customers/?query=' + str);
    // }  
    
    // getCustomerById(str){
    //     return api.get(URL + 'clientById/' + str);
    // }  
    
    getCustomerInvoiceSummeryById(idClient) {
        return api.get(`${URL}/getCustomerInvoiceSummeryById/${idClient}`);
    }


    getInvoiceListOverview(){
        return api.get(`${URL}/invoiceListOverview`);
    }
    
    getAnalyticsGreeting(){
        return api.get(`${URL}/getAnalyticsGreeting`);
    }
    getChartSalesActivity(data){
        const  params = [];
        if( data.range != undefined && data.range != null )
         {
            params.push( "range=" + data.range );
         }
        return api.get( 'dashboard/chart_sale_activity' + (params.length ? '?' + params.join('&') : '' ));
    }
    getTodayAnalytics(){
        return api.get('dashboard/invoice_payment_stats_seven_days' );
    }
    
    getInvoiceAnalyticsByMonths(month){
        return api.get(`${URL}/get_invoice_analytics_by_months`);
    }
    getAnalyticsByNumberOfdays(month){
        return api.get(`${URL}/getAnalyticsByNumberOfdays?month=${month}`);
    }


    getChartInvoicesStatus(){
        return api.get(`${URL}/getChartInvoicesStatus`);
    }

    getAnalyticsInvoicesProcessing(data){
        const  params = [];
        if( data.calRange != undefined && data.calRange != null )
         {
            params.push( "calRange=" + data.calRange );
         }        
        if( data.idClient != undefined && data.idClient != null )
         {
            params.push( "idClient=" + data.idClient );
         }
        return api.get(`${URL}/getAnalyticsInvoicesProcessing` + (params.length ? '?' + params.join('&') : '' ));
    }  
    getAnalyticsInvoicesGrossAndDue(data){

        const  params = [];       
        if( data.idClient != undefined && data.idClient != null )
         {
            params.push( "idClient=" + data.idClient );
         }

        return api.get(`${URL}/getAnalyticsInvoicesGrossAndDue` + (params.length ? '?' + params.join('&') : '' ));
    }  
    getNumberOfInvoicesByFilter(data){

        const  params = [];       
        if( data.idClient != undefined && data.idClient != null )
         {
            params.push( "idClient=" + data.idClient );
         }
        if( data.statusTag != undefined && data.statusTag != null )
         {
            params.push( "statusTag=" + data.statusTag );
         }

        return api.get(`${URL}/getNumberOfInvoicesByFilter` + (params.length ? '?' + params.join('&') : '' ));
    }  

    getChartInvoicesGrossAndTax(){
        // ?idClient=' + idClient
        return api.get(`${URL}/getChartInvoicesGrossAndTax`);
    }  
    
    updateScheduleSender(idInvoice, data){
        return api.put(`${URL}/${idInvoice}/reminders/${data.public_id}`, data)
    }
    createScheduleSender(idInvoice, data){
        return api.post(`${URL}/${idInvoice}/reminders`, data)
    }
    getScheduleSender(idInvoice){
        return api.get(`${URL}/${idInvoice}/reminders/summary`)
    }

    setSendQuotation(data){
        return api.post(`${URL}/sendQuotation`, data)
    }   


    getSendQuotation(idInvoice){
        return api.get(`${URL}/sendQuotation/${idInvoice}`)
    }
    
    setSendEstimate(data){
        return api.post(`${URL}/sendEstimate`, data)
    }   


    getSendEstimate(idInvoice){
        return api.get(`${URL}/sendEstimate/${idInvoice}`)
    }     
    
    setSendInvoice(data){
        return api.post( "sales_emails/" + data.id + "/sale", data)
    }   
    getSendInvoice(idInvoice){
        return api.get( "sales_emails/" + idInvoice + "/sale" )
    }     
    setSendInvoicePayment(data){
        return api.post("sales_emails/"  + data.id + "/payment", data)
    }   
    getSendInvoicePayment(idInvoice){
        return api.get( "sales_emails/" + idInvoice + "/payment")
    }     
    setSendPaymentReceived(data){
        return api.post("sales_emails/" + data.id + "/payment_received", data)
    }
    getSendPaymentReceived(idInvoice){
        return api.get("sales_emails/" + idInvoice + "/payment_received")
    }

    getInvoiceTemplates(){
        return api.get(`${URL}/invoiceTemplates/`)
    }



    /*
    | Manual; payment intent for Stripe
    */
    
   setPaymentIntent(data){
       return api.post(`${URL}/stripe_manual_payment_intent`, data)
    } 
    getPartialOnlinePaymentPending(idInvoice){
        return api.get(`${URL}/stripe_manual_payment_intent/${idInvoice}`)
    } 
    setSendPartialPaymentLink(data){
        return api.post(`${URL}/sendPartialPaymentLink`, data)
    } 
    /*
    | Manual; Payment
    */
    
    getPaymentMethodList(){
        return api.get( "/payment_methods/manual")
    }
    // counts by customer public_id for payments
    getPaymentsCountByCustomer(customerPublicId) {
        return api.get(`/payments/customer_counts/${customerPublicId}`)
    }
    setRecordManualPayment(idInvoice, data){
        return api.post(`${URL}/${idInvoice}/payments/manual`, data)
    } 
    getRecordManualPayment(idInvoice){
        return api.get(`${URL}/recordManualPayment/${idInvoice}`)
    } 
    
    setDeleteManualPayment(data){
        return api.post(`${URL}/deleteManualPayment`, data)
    } 


    /*
    | Estimate
    */
    convertEstimateToInvoice(data){
        return api.post(`${URL}/convertEstimateToInvoice`, data)
    } 
    
    



    



    /*
    | REPORTS
    */

        

    getPaymentReport(data){
        const  params = [];
        if( data.listPageIndex != undefined && data.listPageIndex != null )
         {
            params.push( "listPageIndex=" + data.listPageIndex );
         }
         if( data.listPerPage != undefined && data.listPerPage != null )
         {
            params.push( "listPerPage=" + data.listPerPage );
         }         
         if( data.listSort != undefined && data.listSort != null )
         {
            params.push( "listSort=" + data.listSort );
         }         
         if( data.listSort != undefined && data.listSort != null )
         {
            params.push( "listSort=" + data.listSort );
         }         
         if( data.listSearch != undefined && data.listSearch != null )
         {
            params.push( "listSearch=" + data.listSearch );
         } 
         if( data.listFilters != undefined && data.listFilters != null )
         {
            params.push( "listFilters=" + JSON.stringify(data.listFilters));
         }                                         
         if( data.idStatus != undefined && data.idStatus != null )
         {
            params.push( "idStatus=" + data.idStatus );
         }                         
                         
        return api.get(process.env.PUBLIC_URL + 'payments' + (params.length ? '?' + params.join('&') : '' ));
    }

    getOverdueInvoices() {
        const params = [
            'per_page=5',
            'status_payment=overdue',
            'has_open_balance=1',
            'exclude_workflow_draft=1',
            'exclude_workflow_pending=1',
        ];
        return api.get(`${URL}?` + params.join('&'));
    }

    getDraftInvoices() {
        const params = [
            'per_page=5',
            'status=draft'
        ];
        return api.get(`${URL}?` + params.join('&'));
    }

    getInvoicesDueToday(userTimezone = 'UTC') {
        const today = new Date().toLocaleDateString('en-CA', { timeZone: userTimezone }); // YYYY-MM-DD format
        // console.log('getInvoicesDueToday', today);
        const params = [
            'per_page=5',
            'date_due=' + today,
            'has_open_balance=1',
            'exclude_workflow_draft=1',
            'exclude_workflow_pending=1',
        ];
        return api.get(`${URL}?` + params.join('&'));
    }

    // getCustomInvoicePDF(data){

    //     const  params = [];
    //     if( data.publicParams != undefined && data.publicParams != null )
    //      {
    //         params.push( "p=" + data.publicParams );
    //      }
    //     if( data.publicUuid != undefined && data.publicUuid != null )
    //      {
    //         params.push( "uuid=" + data.publicUuid );
    //      }

    //     return fetch('https://api.suite.gridbind.com/share_page/invoice_pdf' + (params.length ? '?' + params.join('&') : '' ))
    //     .then((response) => response.blob())
    //     .then((response) => {
    //         return response;
    //     });


    // } 





    sendCancelEmail(id, data) {
        return api.post('sales_emails/' + id + '/cancel', data);
    }

    getWorkflowStatuses(id) {
        return api.get(`${URL}/${id}/workflow_statuses`);
    }

    /**
     * The ORGANIZATION's configured workflow statuses — same org-wide list as the per-invoice call
     * above, but without needing an invoice. Use this to populate anything that OFFERS statuses to
     * the user (list filters, search), so we never suggest a phase this org does not run.
     */
    getOrganizationWorkflowStatuses() {
        return api.get(`${URL}/workflow_statuses`);
    }

    // PDF Methods
    downloadInvoicePDF(publicId, type = 'a4', fileName = null) {
        return api.get(`${URL}/${publicId}/pdf/download/${type}`, {
            responseType: 'blob'
        })
        .then(response => {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            // Use provided fileName or fallback to public_id
            a.download = fileName || `invoice_${publicId}_${type}.pdf`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        })
        .catch(error => {
            console.error('Error downloading PDF:', error);
            // Use centralized error handler
            // For blob responses, we need to handle them specially
            if (error.response && error.response.data instanceof Blob) {
                const reader = new FileReader();
                reader.onload = () => {
                    try {
                        const errorData = JSON.parse(reader.result);
                        varexeAPIResponseHandler.error(errorData.message || errorData.data?.message || 'Failed to download PDF');
                    } catch (e) {
                        varexeAPIResponseHandler.error('Failed to download PDF. Please check if wkhtmltopdf is properly installed.');
                    }
                };
                reader.readAsText(error.response.data);
            } else {
                // Use varexeAPIResponseHandler for non-blob errors
                varexeAPIResponseHandler.handleError(error, { skipAutoHandling: false });
            }
        });
    }

    viewInvoicePDF(publicId, type = 'a4') {
        return api.get(`${URL}/${publicId}/pdf/view/${type}`, {
            responseType: 'blob'
        })
        .then(response => {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');
        })
        .catch(error => {
            console.error('Error viewing PDF:', error);
            // Use centralized error handler
            if (error.response && error.response.data instanceof Blob) {
                const reader = new FileReader();
                reader.onload = () => {
                    try {
                        const errorData = JSON.parse(reader.result);
                        varexeAPIResponseHandler.error(errorData.message || errorData.data?.message || 'Failed to view PDF');
                    } catch (e) {
                        varexeAPIResponseHandler.error('Failed to view PDF. Please check if wkhtmltopdf is properly installed.');
                    }
                };
                reader.readAsText(error.response.data);
            } else {
                varexeAPIResponseHandler.handleError(error, { skipAutoHandling: false });
            }
        });
    }

    printInvoicePDF(publicId, type = 'a4') {
        return api.get(`${URL}/${publicId}/pdf/print/${type}`, {
            responseType: 'blob'
        })
        .then(response => {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const printWindow = window.open(url, '_blank');
            printWindow.onload = () => printWindow.print();
        })
        .catch(error => {
            console.error('Error printing PDF:', error);
            // Use centralized error handler
            if (error.response && error.response.data instanceof Blob) {
                const reader = new FileReader();
                reader.onload = () => {
                    try {
                        const errorData = JSON.parse(reader.result);
                        varexeAPIResponseHandler.error(errorData.message || errorData.data?.message || 'Failed to print PDF');
                    } catch (e) {
                        varexeAPIResponseHandler.error('Failed to print PDF. Please check if wkhtmltopdf is properly installed.');
                    }
                };
                reader.readAsText(error.response.data);
            } else {
                varexeAPIResponseHandler.handleError(error, { skipAutoHandling: false });
            }
        });
    }

    downloadWorkOrderPDF(publicId, fileName = null) {
        return api.get(`${URL}/${publicId}/work_order/pdf/download`, {
            responseType: 'blob'
        })
        .then(response => {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            // Use provided fileName or fallback to public_id
            a.download = fileName || `work_order_${publicId}.pdf`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        })
        .catch(error => {
            console.error('Error downloading work order PDF:', error);
            // Use centralized error handler
            if (error.response && error.response.data instanceof Blob) {
                const reader = new FileReader();
                reader.onload = () => {
                    try {
                        const errorData = JSON.parse(reader.result);
                        varexeAPIResponseHandler.error(errorData.message || errorData.data?.message || 'Failed to download work order PDF');
                    } catch (e) {
                        varexeAPIResponseHandler.error('Failed to download work order PDF. Please check if wkhtmltopdf is properly installed.');
                    }
                };
                reader.readAsText(error.response.data);
            } else {
                varexeAPIResponseHandler.handleError(error, { skipAutoHandling: false });
            }
        });
    }

    viewWorkOrderPDF(publicId) {
        return api.get(`${URL}/${publicId}/work_order/pdf/view`, {
            responseType: 'blob'
        })
        .then(response => {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');
        })
        .catch(error => {
            console.error('Error viewing work order PDF:', error);
            // Use centralized error handler
            if (error.response && error.response.data instanceof Blob) {
                const reader = new FileReader();
                reader.onload = () => {
                    try {
                        const errorData = JSON.parse(reader.result);
                        varexeAPIResponseHandler.error(errorData.message || errorData.data?.message || 'Failed to view work order PDF');
                    } catch (e) {
                        varexeAPIResponseHandler.error('Failed to view work order PDF. Please check if wkhtmltopdf is properly installed.');
                    }
                };
                reader.readAsText(error.response.data);
            } else {
                varexeAPIResponseHandler.handleError(error, { skipAutoHandling: false });
            }
        });
    }

    printWorkOrderPDF(publicId) {
            return api.get(`${URL}/${publicId}/work_order/pdf/print`, {
            responseType: 'blob'
        })
        .then(response => {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const printWindow = window.open(url, '_blank');
            printWindow.onload = () => printWindow.print();
        })
        .catch(error => {
            console.error('Error printing work order PDF:', error);
            // Use centralized error handler
            if (error.response && error.response.data instanceof Blob) {
                const reader = new FileReader();
                reader.onload = () => {
                    try {
                        const errorData = JSON.parse(reader.result);
                        varexeAPIResponseHandler.error(errorData.message || errorData.data?.message || 'Failed to print work order PDF');
                    } catch (e) {
                        varexeAPIResponseHandler.error('Failed to print work order PDF. Please check if wkhtmltopdf is properly installed.');
                    }
                };
                reader.readAsText(error.response.data);
            } else {
                varexeAPIResponseHandler.handleError(error, { skipAutoHandling: false });
            }
        });
    }

}

export default new InvoiceService()
